import { config } from '@rematter/config';
import { getTalkSession } from '@talkjs/core';
import { atom, getDefaultStore } from 'jotai';

export const $userId = atom<string | undefined>(undefined);

const $talkSessionVersion = atom(Date.now());

export const $talkSession = atom((get) => {
  void get($talkSessionVersion);

  const userId = get($userId);

  if (!userId) return undefined;

  setTimeout(() => {
    const store = getDefaultStore();
    store.set($talkSessionVersion, Date.now());
  }, 10_000);

  return getTalkSession({
    appId: config.talkJs.appId,
    userId: userId,
  });
});
